import { useQuery } from '@tanstack/vue-query';
import { type Ref, unref } from 'vue';

import hardwareFormService from '../../services/hardwareFormService';

export default function useHardwareForm(projectId: Ref<string> | string) {
  return useQuery({
    enabled: !!unref(projectId),
    queryFn: async () => {
      const id = unref(projectId);
      if (!id) throw new Error('Project ID is required');
      return hardwareFormService.getHardwareForm(id);
    },
    queryKey: ['hardware-form', projectId],
    retry: 3,
  });
}
